import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'base-button',
  templateUrl: './base-button.component.html',
  styleUrls: ['./base-button.component.scss']
})
export class BaseButtonComponent {
  @Input() ariaLabel = null;
  @Input() buttonClass = '';
  @Input() color = 'primary';
  @Input() disabled = false;
  @Input() height = 'medium';
  @Input() icon = '';
  @Input() iconClass = '';
  @Input() iconColor = '';
  @Input() iconSize = 'small';
  @Input() loading = false;
  @Input() rounded = 'normal';
  @Input() src = '';
  @Input() srcClass = '';
  @Input() text = '';
  @Input() type = 'button';
  @Input() width = '150px';
  @Output('onClick') emitClick = new EventEmitter();

  onClick(): void {
    if (!this.loading && !this.disabled) {
      this.emitClick.emit();
    }
  }
}
